import { fieldClass } from "./fields";

/**
 * The currency every priced row in this catalog is quoted in.
 *
 * ONE control for the whole catalog, not one per row, even though
 * `products.currency` is a per-row column: an order carries a single currency
 * and a cart that mixes two is refused, so making mixed currencies
 * unrepresentable here is cheaper than detecting them at checkout.
 *
 * A closed list rather than a free text field: the value is an ISO-4217 code
 * that `Intl.NumberFormat` must recognise, and a typo ("MNX") throws in the
 * prompt builder rather than showing a wrong price — which is to say it would
 * fail at the worst possible moment.
 */
const CURRENCIES = [
  { code: "MXN", label: "Peso mexicano (MXN)" },
  { code: "USD", label: "Dólar estadounidense (USD)" },
  { code: "EUR", label: "Euro (EUR)" },
] as const;

export function CurrencySelect({
  value,
  onChange,
  disabled,
}: {
  value: string;
  onChange: (currency: string) => void;
  disabled?: boolean;
}): React.JSX.Element {
  return (
    <div className="flex flex-wrap items-center gap-2 rounded-lg border border-ink-100 bg-white px-4 py-3">
      <label htmlFor="catalog-currency" className="text-[13px] font-medium text-ink-800">
        Moneda
      </label>
      <select
        id="catalog-currency"
        className={`${fieldClass({})} w-56`}
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
      >
        {/* A stored code outside the list (set by an import, or by a build that
            offered more) must still be selectable — a select whose value matches
            no option renders blank and the next save would silently change it. */}
        {!CURRENCIES.some((c) => c.code === value) && <option value={value}>{value}</option>}
        {CURRENCIES.map((c) => (
          <option key={c.code} value={c.code}>
            {c.label}
          </option>
        ))}
      </select>
      <span className="text-[12.5px] text-ink-500">
        Los precios del catálogo se cotizan en esta moneda.
      </span>
    </div>
  );
}
